<template>
  <sys-data-table
    :height="alturaDaJanela - 430"
    :item-height="45"
    :headers="cabecalhos"
    :items="produtos_locais"
    hide-default-footer
    :search="pesquisa"
  >
    <template #top="{ rows }">
      <div class="d-flex align-center w-full py-5">
        <div class="d-flex align-center">
          <p class="ma-0 text-systock-blue font-weight-medium">Ítens do Pedido</p>
          <span class="pl-3">{{ rows.length }} itens</span>
        </div>

        <v-spacer />

        <div class="w-400">
          <v-text-field
            :value="pesquisa"
            @input="$emit('update:pesquisa', $event)"
            label="Pesquisar Produto"
            outlined
            dense
            hide-details
            prepend-inner-icon="mdi-magnify"
          />
        </div>

        <slot name="top.right"></slot>
      </div>
    </template>

    <template #item.descricao_produto="{ item }">
      <div class="d-flex align-center">
        <DetalhesProduto
          :produto="{...item, id_filial: filial_pedido, id_produto: item.idproduto}"
          class="ml-n1"
        />

        <span v-text="`${item.idproduto} - ${item.descricao_produto}`" />
      </div>
    </template>

    <template #item.cobertura_futura_depois="{ item }">
      <div class="d-flex align-center">
        <v-chip class="px-4" small>
          {{ Helpers.formatarValorComCasas(item.cobertura_futura_antes, 0) }}
        </v-chip>

        <v-icon class="px-2" :size="25">$ArrowRight</v-icon>

        <v-chip class="px-4" small>
          {{ Helpers.formatarValorComCasas(item.cobertura_futura_depois, 0) }}
        </v-chip>
      </div>
    </template>

    <template #item.qtd_inicial="{ item }">
      {{ Helpers.formatarValor(item.qtd_inicial) }}
    </template>

    <template #item.qtd_ajustada="{ item }">
      <div class="w-100">
        <TextFieldFormatadorDeValor
          v-model="item.qtd_ajustada"
          hide-details
          dense
          clearable
          class="text-field-centralizado font-12"
          @focus="ev => ev.target.select()"
          @input="() => reprocessarValoresLinha(item)"
          :maxlength="item.qtd_ajustada === 0 ? 1 : ''"
        />
      </div>
    </template>

    <template #item.total_inicial="{ item }">
      {{ Helpers.formatarValorMonetario(item.total_inicial) }}
    </template>

    <template #item.total_ajustado="{ item }">
      {{ Helpers.formatarValorMonetario(item.total_ajustado) }}
    </template>

    <template #item.acao="{ item }">
      <CardMudanca v-if="item.acao" :cor="item.acao">
        {{ item.acao !== 'EXCLUIDO' ? Helpers.primeiraLetraMaiuscula(item.acao) : 'Excluído' }}
      </CardMudanca>

      <div v-else>-</div>
    </template>

    <template #item.motivos="{ item }">
      <ObservacoesAjustePedido
        :motivos="item.motivos"
        :produto="item"
      />
    </template>
  </sys-data-table>
</template>

<script>
import ResponsiveHeight from "@/helpers/ResponsiveHeight";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import CardMudanca from "@/components/compra/ProdutosGerais/Carrinho/Meta/EntendaOQueMudou/CardMudanca.vue";
import CalculaCoberturaEstoqueFutura from "@/components/compra/CalculaCoberturaEstoqueFutura.vue";
import ObservacoesAjustePedido from "@/components/compra/ProdutosGerais/Carrinho/ListaProdutos/ObservacoesAjustePedido.vue";
import {coberturaFuturaEmDias, getAcao} from "@/components/compra/ProdutosGerais/Carrinho/Meta/utils";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";

export default {
  name: "Tabela",
  components: {
    DetalhesProduto,
    ObservacoesAjustePedido,
    CalculaCoberturaEstoqueFutura,
    CardMudanca,
    TextFieldFormatadorDeValor
  },
  mixins: [ResponsiveHeight],
  props: {
    produtos: Array,
    filial_pedido: Number,
    pesquisa: String,
  },
  data: () => ({
    cabecalhos: [
      { text: 'Produto', value: 'descricao_produto' },
      { text: 'Un. Medida', value: 'idunidade_medida' },
      { text: 'Cobertura Futura (dias)', value: 'cobertura_futura_depois' },
      { text: 'Qtd Inicial', value: 'qtd_inicial' },
      { text: 'Qtd Ajustada', value: 'qtd_ajustada' },
      { text: 'Valor Inicial', value: 'total_inicial' },
      { text: 'Valor Ajustado', value: 'total_ajustado' },
      { text: 'Ação', value: 'acao', style: { textAlign: 'center' }},
      { text: '', value: 'motivos', style: { width: '30px' }},
    ],
    ignorarSyncProdutos: false,
    produtos_locais: []
  }),
  watch: {
    produtos: {
      immediate: true,
      handler(novo) {
        if (this.ignorarSyncProdutos) {
          this.ignorarSyncProdutos = false;
          return;
        }

        if (!Array.isArray(novo)) {
          this.produtos_locais = [];
          return;
        }

        this.produtos_locais = novo.map((p) => {
          const qtd_inicial = Number(p.qtd_inicial || 0);
          const qtd_ajustada = Number(p.qtd_ajustada || 0);

          const preco_custo = Number(p.preco_custo || 0);
          const vlr_ajustado = Number(p.vlr_ajustado || 0);

          return {
            ...p,
            total_inicial: preco_custo * qtd_inicial,
            total_ajustado: vlr_ajustado * qtd_ajustada,
          };
        });
      },
    },
  },
  methods: {
    emitirAtualizacaoProdutos() {
      this.ignorarSyncProdutos = true;
      this.$emit("update:produtos", this.produtos_locais);
    },
    reprocessarValoresLinha(item) {
      item.acao = getAcao(item);

      item.cobertura_futura_antes = coberturaFuturaEmDias({
        consumo_medio_mensal: item.consumo_medio_mensal,
        sugestao: item.qtd_inicial,
        estoque_futuro_tempo_ressuprimento: item.estoque_futuro_tempo_ressuprimento,
      });

      item.cobertura_futura_depois = coberturaFuturaEmDias({
        consumo_medio_mensal: item.consumo_medio_mensal,
        sugestao: item.qtd_ajustada,
        estoque_futuro_tempo_ressuprimento: item.estoque_futuro_tempo_ressuprimento,
      });

      const qtd_inicial = Number(item.qtd_inicial || 0);
      const qtd_ajustada = Number(item.qtd_ajustada || 0);
      const preco_custo = Number(item.preco_custo || 0);
      const vlr_ajustado = Number(item.vlr_ajustado || 0);

      item.total_inicial = preco_custo * qtd_inicial;
      item.total_ajustado = vlr_ajustado * qtd_ajustada;

      this.emitirAtualizacaoProdutos();
    }
  },
}
</script>
